export default {
  colors: {
    blueEinstein: '#004F92',
    backgroundColor: '#ffffff',
    colorGray100: '#E8E8E8',
    colorGray300: '#d5d5d6',
    colorGray400: '#898B8E',
    colorGray500: '#555658',
    colorSuccess: '#00b193',
    colorDanger: '#ef4f4c'
  },
  fontWeight: {
    medium: 500,
    semibold: 600,
    bold: 700
  },
  layers: {
    base: 10,
    menu: 20,
    overlay: 30,
    modal: 40,
    alwaysOnTop: 50
  }
} as const;
